import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Clock, MessageSquare } from "lucide-react";

const MS_PER_MINUTE = 60_000;
const MIN_PER_HOUR = 60;
const HOUR_PER_DAY = 24;

const URGENCY_STYLES = {
  ASAP: "bg-red-50 text-red-700 border-red-200",
  "Within a Week": "bg-orange-50 text-orange-700 border-orange-200",
  Flexible: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

function timeAgo(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  const m = Math.floor((Date.now() - t) / MS_PER_MINUTE);
  if (m < 1) return "just now";
  if (m < MIN_PER_HOUR) return `${m}m ago`;
  const h = Math.floor(m / MIN_PER_HOUR);
  if (h < HOUR_PER_DAY) return `${h}h ago`;
  return `${Math.floor(h / HOUR_PER_DAY)}d ago`;
}

export default function JobCard({ job }) {
  return (
    <Link to={`/jobs/${job.id}`} data-testid={`job-card-${job.id}`} className="block">
      <Card className="tf-card-hover border-slate-200 h-full">
        <CardContent className="p-6">
          <div className="flex items-start justify-between gap-3">
            <Badge variant="outline" className="border-blue-200 text-blue-900 font-normal">
              {job.category}
            </Badge>
            <Badge
              className={`${URGENCY_STYLES[job.urgency] || "bg-slate-100 text-slate-700"} border font-normal`}
            >
              {job.urgency}
            </Badge>
          </div>

          <h3 className="font-display font-semibold text-lg text-slate-900 mt-3 leading-snug line-clamp-2">
            {job.title}
          </h3>

          <p className="text-sm text-slate-600 mt-2 line-clamp-2">{job.description}</p>

          <div className="flex items-center gap-4 mt-5 pt-4 border-t border-slate-100 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1">
              <MapPin className="w-3.5 h-3.5" />
              {job.city}
            </span>
            <span className="inline-flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" /> {timeAgo(job.created_at)}
            </span>
            <span className="inline-flex items-center gap-1 ml-auto">
              <MessageSquare className="w-3.5 h-3.5" /> {job.quote_count ?? (job.quotes || []).length} quote
              {(job.quote_count ?? (job.quotes || []).length) === 1 ? "" : "s"}
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
